import React, { useState } from "react";
import "../css/mobileapp.css";
import logo1 from "../assets/logo.png";

export default function PdfLibrary() {

  const [selectedPdf, setSelectedPdf] = useState(null);

  const pdfList = [
        {
      title: "booth 14",
      file: "/pdfs/14.pdf",   
    },
        {
      title: "booth 15",
      file: "/pdfs/15.pdf",   
    },
        {
      title: "booth 16",
      file: "/pdfs/16.pdf",   
    },
        {
      title: "booth 17",
      file: "/pdfs/17.pdf",   
    },
        {
      title: "booth 18",
      file: "/pdfs/18.pdf",   
    },
        {
      title: "booth 19",
      file: "/pdfs/19.pdf",   
    },
        {
      title: "booth 20",
      file: "/pdfs/20.pdf",   
    },
        {
      title: "booth 21",
      file: "/pdfs/21.pdf",   
    },
        {
      title: "booth 22",
      file: "/pdfs/22.pdf",   
    },
        {
      title: "booth 23",
      file: "/pdfs/23.pdf",   
    },
        {
      title: "booth 24",
      file: "/pdfs/24.pdf",   
    },
        {
      title: "booth 25",
      file: "/pdfs/25.pdf",   
    },
        {
      title: "booth 26",
      file: "/pdfs/26.pdf",   
    },
    {
      title: "booth 27",
      file: "/pdfs/27.pdf",   
    },
        {
      title: "booth 28",
      file: "/pdfs/28.pdf",   
    },
        {
      title: "booth 29",
      file: "/pdfs/29.pdf",   
    },
        {
      title: "booth 30",
      file: "/pdfs/30.pdf",   
    },
        {
      title: "booth 31",
      file: "/pdfs/31.pdf",   
    },
        {
      title: "booth 32",
      file: "/pdfs/32.pdf",   
    },
        {
      title: "booth 33",
      file: "/pdfs/33.pdf",   
    },
        {
      title: "booth 34",
      file: "/pdfs/34.pdf",   
    },
        {
      title: "booth 35",
      file: "/pdfs/35.pdf",   
    },
        {
      title: "booth 36",
      file: "/pdfs/36.pdf",   
    },
        {
      title: "booth 37",
      file: "/pdfs/37.pdf",   
    },
  ];

  return (
    <div className="mobile-container">

      {/* HEADER */}
      <div className="mobile-header">
        <img src={logo1} alt="TVK Logo" className="mobile-logo" />
      </div>

      <div className="pdf-page">

        <h2 className="contact-title">📄 ஆவணங்கள்</h2>

        {/* PDF LIST */}
        {!selectedPdf && (
      <div className="pdf-grid">
        {pdfList.map((pdf, index) => (
          <div
            key={index}
            className="pdf-card"
            onClick={() => setSelectedPdf(pdf.file)}
          >
            <div className="pdf-icon">📄</div>
            <div className="pdf-title">{pdf.title}</div>
          </div>
        ))}
      </div>
        )}

        {/* PDF VIEWER */}
        {selectedPdf && (
          <div className="pdf-viewer">
            <button
              className="back-btn"
              onClick={() => setSelectedPdf(null)}
            >
              ⬅ திரும்ப
            </button>

          <iframe
            src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${window.location.origin}${selectedPdf}`}
            title="PDF Viewer"
            width="100%"
            height="600px"
          />
          </div>
        )}

      </div>

    </div>
  );
}